import React, { FunctionComponent, ReactNode, useState } from "react"

interface IDropFilesProps {
    onDrop(file: File[]): any
    children(params: { isDragOver: boolean }): ReactNode
    enabled?: boolean
}

const DropFiles: FunctionComponent<IDropFilesProps> = ({
    onDrop,
    children,
    enabled
}) => {
    const [isDragOver, setIsDragOver] = useState(false)

    function handleDragEnter(e: React.DragEvent<HTMLDivElement>) {
        if (!enabled) return
        e.preventDefault()
        e.stopPropagation()
        setIsDragOver(true)
    }

    function handleDragLeave(e: React.DragEvent<HTMLDivElement>) {
        if (!enabled) return
        e.preventDefault()
        e.stopPropagation()
        setIsDragOver(false)
    }

    function handleDragOver(e: React.DragEvent<HTMLDivElement>) {
        if (!enabled) return
        e.preventDefault()
        e.stopPropagation()
        setIsDragOver(true)
    }

    function handleDrop(e: React.DragEvent<HTMLDivElement>) {
        if (!enabled) return
        e.preventDefault()
        e.stopPropagation()
        setIsDragOver(false)
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            onDrop(Array.from(e.dataTransfer.files))
            e.dataTransfer.clearData()
        }
    }

    return (
        <div
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDragOver={handleDragOver}
            onDrop={handleDrop}>
            {children({ isDragOver })}
        </div>
    )
}

export default DropFiles
